import React, { useEffect, useState } from "react";
import "../announcement/styles/index.less";
import {
  Col,
  Row,
  Layout,
  Button,
  Table,
  Tooltip,
  Switch,
  Modal,
  Input,
  Form,
  Radio,
  Typography,
  Spin,
  Breadcrumb,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleFilled,
  PlusOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import {
  announcement_create,
  announcement_delete,
  get_all_announcement,
  announcement_update_status,
} from "../../services/announcement";
import { useAuth } from "../../utils/Auth/AuthWrapper";
import dayjs from "dayjs";
import "dayjs/locale/th";
import buddhistEra from "dayjs/plugin/buddhistEra";
import { useTranslation } from "react-i18next";

dayjs.extend(buddhistEra);

interface Values {
  title_announcement: string;
  type: string;
  createDate: string;
  dateTime: string;
}

interface Announcement {
  colordetail: string;
  summarize: string;
  readMore: any;
  url: any;
  colorbutton: string;
  colortitle: string;
  textPosition: string;
  colorbackground: any;
  backcolor: any;
  detail: string;
  id: number;
  announcement_id: string;
  announcement_type: number;
  title: string;
  content: string; // เนื่องจาก content เป็น JSON string คุณสามารถ parse เพิ่มเติมได้ในภายหลัง
  created_date: string;
  img: string | null;
  link: string | null;
  created_by: string;
  status: number;
}

const { Content } = Layout;
const { Search } = Input;
const { confirm } = Modal;
const { Title } = Typography;

type Props = {};

const Announcement = (props: Props) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [formValues, setFormValues] = useState<Values>();
  const [searchText, setSearchText] = useState("");
  const [open, setOpen] = useState(false);
  const auth = useAuth();
  const { t } = useTranslation();
  const [announceData, setAnnounceData] = useState([
    {
      key: "1",
      title: "Exciting New Product Launch: Introducing the UltraTech X1!",
      content: "test",
      created_date: "2025-01-06 03:40:33",
      status: 1,
    },
    {
      key: "2",
      title: "Exciting New Product Launch: Introducing the UltraTech X1!",
      content: "test",
      created_date: "2025-01-06 03:40:33",
      status: 1,
    },
  ]);
  const [filteredData, setFilteredData] = useState<
    {
      key: string;
      title: string;
      created_date: string;
      status: number;
    }[]
  >([]);
  const [isLoading, setIsLoading] = useState(true);
  const [expandedRowKeys, setExpandedRowKeys] = useState<React.Key[]>([]);

  // แปลงจาก 10/12/2024 เป็น 10 ธันวาคม 2567
  const formatThaiDate = (dateString: any) => {
    return dayjs(dateString)
      .locale("th") // ✅ ตั้งค่าภาษาไทย
      .format("D MMMM BBBB"); // ✅ แสดงเป็น "1 มกราคม 2568"
  };

  // create announce
  const onCreate = async (values: Values) => {
    try {
      const res = await announcement_create({
        announcement_type: values.type == "create" ? 1 : 2,
        title:
          values.title_announcement === undefined
            ? ""
            : values.title_announcement,
        img: null,
        user_id: auth.user.user_id,
      });
    } catch (e) {
      console.error(e);
    }
    getAnnounce();
    setOpen(false);
    navigate(
      "/announcement/new/" + values.type + "/" + values.title_announcement
    );
  };

  // api delete
  const showDeleteConfirm = (id: string, title: string) => {
    confirm({
      title: t("delete title"),
      icon: <ExclamationCircleFilled style={{ color: "#FF3B30" }} />,
      content: (
        <div
          className="custom-modal-content-news"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center", // จัดข้อความให้อยู่ตรงกลาง
          }}
        >
          <p>{t("delete detail announcement")} :</p>
          <p>
            <strong>{title}</strong>
          </p>
          <p>{t("yes or no")}</p>
        </div>
      ),
      okText: t("confirm"),
      okType: "danger",
      cancelText: t("cancel"),
      onOk: async () => {
        try {
          const res = await announcement_delete({ announcement_id: id });
          getAnnounce();
        } catch (e) {
          console.error(e);
        }
      },
      onCancel() {},
    });
  };

  // api Announce
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true); // ✅ เริ่มโหลด
      await getAnnounce(); // ✅ ดึงข้อมูล
      setIsLoading(false); // ✅ โหลดเสร็จ
    };
    fetchData();
  }, []);

  const getAnnounce = async () => {
    const res = await get_all_announcement();
    setAnnounceData(res.result);
  };

  // table
  const columns: any["columns"] = [
    {
      title: (
        <div style={{ fontSize: "18px", textAlign: "center" }}>
          {t("name announcement")}
        </div>
      ),
      dataIndex: "title",
      key: "title",
    },
    {
      title: (
        <div style={{ fontSize: "18px", textAlign: "center" }}>
          {t("create date")}
        </div>
      ),
      dataIndex: "created_date",
      key: "created_date",
      render: (_: any, record: any) => {
        return formatThaiDate(_);
      },
    },
    {
      title: (
        <div style={{ fontSize: "18px", textAlign: "center" }}>
          {t("Active")}
        </div>
      ),
      align: "center",
      render: (_: any, record: any) => {
        return (
          <Switch
            defaultChecked={record.status === 1}
            onChange={(value) => handleChangeStatus(record, value)} // ใช้ onChange แทน onClick
          />
        );
      },
    },
    {
      title: "",
      key: "action",
      render: (_: any, record: any) => (
        <Row justify="center" align="middle">
          {/* <Tooltip placement="bottom" title="Detail">
            <Col
              style={{
                color: "#0958d9",
                cursor: "pointer",
              }}
            >
              <Button
                style={{ backgroundColor: "#d1d7fa" }}
                icon={<FileSearchOutlined style={{ color: "#615EFC" }} />}
                onClick={() => handleExpandRow(record.id, record.content)} // ย้าย onClick มานอก icon
              />
            </Col>
          </Tooltip> */}

          <Tooltip placement="bottom" title="Edit">
            <Col
              style={{
                color: "#0958d9",
                cursor: "pointer",
                marginLeft: "10px",
              }}
              onClick={() => {
                navigate("/announcement/edit/" + record.announcement_id);
              }}
            >
              <Button
                style={{ backgroundColor: "#fff4cc" }}
                icon={<EditOutlined style={{ color: "#FFB84C" }} />}
              />
            </Col>
          </Tooltip>

          <Tooltip placement="bottom" title="Delete">
            <Col
              style={{
                color: "#0958d9",
                cursor: "pointer",
                marginLeft: "10px",
              }}
              onClick={() => {
                if (record.role_id == "99999999-0000-0000-0000-999999999999") {
                  Modal.error({
                    title: "Permission Denined!",
                    content: `Not allow to edit Super Admin's data.`,
                  });
                } else {
                  showDeleteConfirm(record.announcement_id, record.title);
                }
              }}
            >
              <Button
                style={{ backgroundColor: "#FFDFDF" }}
                icon={<DeleteOutlined style={{ color: "#B31312" }} />}
              />
            </Col>
          </Tooltip>
        </Row>
      ),
    },
  ];

  // const handleExpandRow = (id: any, content: any) => {
  //   try {
  //     const key = id;
  //     const parsedContent = content ? JSON.parse(content) : [];
  //     const details = parsedContent[0].details || [];
  //     setCarouselData(details);
  //     setExpandedRowKeys((prevKeys) =>
  //       prevKeys.includes(id)
  //         ? prevKeys.filter((k) => k !== id)
  //         : [...prevKeys, id]
  //     );

  //     if (expandedRowKeys.includes(id)) {
  //       setExpandedRowKeys([]);
  //     } else {
  //       setExpandedRowKeys([id]);
  //     }
  //   } catch (error) {
  //     console.error("Error parsing content:", error);
  //   }
  // };

  const handleChangeStatus = async (record: any, value: boolean) => {
    try {
      const res = await announcement_update_status({
        status: value ? 1 : 2,
        announcement_id: record.announcement_id,
      });
      await get_all_announcement();
    } catch (e) {
      console.error(e);
    }
  };

  // search
  useEffect(() => {
    let filtered = [];
    filtered = announceData.filter((data) =>
      data.title.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredData(filtered);
  }, [searchText, announceData]);

  const onSearch = (value: any) => {
    setSearchText(value);
  };



  return (
    <Layout>
      <Content className="announcement-layout">
        <div>
          <Row justify="space-between" align="middle">
            <Breadcrumb
              separator=">"
              items={[
                {
                  title: (
                    <span style={{ fontWeight: "bold" }}>
                      {t("Announcement")}
                    </span>
                  ),
                },
              ]}
            />
            <Col>
              <Search
                placeholder="Search"
                style={{ width: 300, marginRight: "10px" }}
                onChange={(e) => onSearch(e.target.value)}
                onSearch={onSearch}
              />
              <Button
                style={{ backgroundColor: "#00215E", color: "white" }}
                onClick={() => setOpen(true)}
              >
                <PlusOutlined />
                {t("Add Announcement")}
              </Button>
            </Col>
          </Row>
          <hr />
        </div>
      </Content>



      <Content className="branner-layout">
        {isLoading ? (
          <Row justify="center" align="middle" style={{ height: "50vh" }}>
            <Spin size="large" />
          </Row>
        ) : (
          <Table
            className="custom-table"
            columns={columns}
            dataSource={filteredData}
            rowKey="id"
            pagination={{
              showTotal: (total, range) =>
                `แสดงรายการต่อหน้า : ${range[0]}-${range[1]} จาก ${total} รายการ`,
              defaultPageSize: 10,
              showSizeChanger: true,
              pageSizeOptions: ["10", "25", "50", "100"],
            }}
            scroll={{ x: "max-content" }}
          />
        )}
      </Content>


      <Modal
        open={open}
        title={t("Add Announcement")}
        okText={t("Add Announcement")}
        cancelText={t("cancel")}
        okButtonProps={{ autoFocus: true, htmlType: "submit" }}
        onCancel={() => setOpen(false)}
        destroyOnClose
        modalRender={(dom) => (
          <Form
            layout="vertical"
            form={form}
            name="form_in_modal"
            initialValues={{ modifier: "public" }}
            onFinish={(values) => onCreate(values)}
          >
            {dom}
          </Form>
        )}
      >
        <Form.Item
          name="title_announcement"
          label={t("name announcement")}
          rules={[{ required: true, message: "Please banner name!" }]}
          style={{ marginTop: "20px" }}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="type"
          className="collection-create-form_last-form-item"
          label={t("type announcement")}
          rules={[{ required: true, message: "Please type of banner!" }]}
        >
          <Radio.Group>
            <Radio value="upload">{t("upload announcement")}</Radio>
            <Radio value="create">{t("create announcement")}</Radio>
          </Radio.Group>
        </Form.Item>
      </Modal>
    </Layout>
  );
};

export default Announcement;
